<template>
  <div
    v-if="isDesktop"
    class="flex justify-between py-6"
    style="border-bottom: 1px solid #ffffff1a"
  >
    <div class="flex-1 flex items-center h-10 mr-6">
      <div
        class="topa-btn px-4 mr-8 text font-bold cursor-pointer text-sm"
        :class="{
          'topa-btn__active': i == (state.isActivity ? 1 : 0),
        }"
        @click="state.isActivity = !!i"
        v-for="(text, i) in ['Asset', 'Activity']"
        :key="i"
      >
        {{ text }}
      </div>
      <ContractSearch
        v-if="!state.isActivity"
        @search="clickDetails"
      ></ContractSearch>
    </div>

    <SearchCell
      v-if="!state.isActivity"
      placeholder="Owner address"
      :onSearch="onAddressSearch"
      @lay="doAddressSearch"
      :alignRight="true"
    ></SearchCell>
  </div>
  <div v-if="!isDesktop">
    <CustomTabs
      :startingIndex="state.isActivity ? 1 : 0"
      :handle-click="
        (i) => {
          state.isActivity = i;
        }
      "
    >
      <template #header>
        <div class="my-2">
          <ContractSearch @search="clickDetails" class="mb-2"></ContractSearch>
          <SearchCell
            placeholder="Owner address"
            :onSearch="onAddressSearch"
            @lay="doAddressSearch"
            :alignRight="true"
          ></SearchCell>
        </div>
      </template>
      <CustomTab title="Asset" :doAddressSearch="doAddressSearch">
        <div
          class="w-full overflow-x-auto mt-4 relative whitespace-nowrap"
          style="min-height: calc(100vh - 144px)"
        >
          <div style="min-width: max-content">
            <!-- T-header -->
            <table
              class="sticky w-full rounded-lg overflow-hidden"
              style="top: 0px; z-index: 2"
            >
              <colgroup>
                <col style="width: 11%" />
                <col style="width: 36%" />
                <col style="width: 11%" />
                <col style="width: 12.7%" />
                <col style="width: 18.3%" />
                <col style="width: 11%" />
              </colgroup>
              <thead
                class="text-left px-6 h-10 md:h-16 text-xs"
                style="background: #2a2e34"
              >
                <td class="table-shadow-left">
                  <div class="px-4">#</div>
                </td>
                <td>
                  <!--  background: #2a2e33ff -->
                  <div class="px-4 h-8 flex items-center">Project</div>
                </td>
                <td>
                  <div
                    class="px-4 cursor-pointer flex items-center"
                    @click="doAssetsOrder"
                  >
                    <span class="mr-2"> Assets </span>
                    <img
                      v-if="state.assetsOrder == -1"
                      class="w-3 h-3"
                      src="@/assets/icons/sort-default.avif"
                      alt=""
                    />
                    <img
                      v-if="state.assetsOrder == 0"
                      class="w-3 h-3"
                      src="@/assets/icons/sort-down.avif"
                      alt=""
                    />
                    <img
                      v-if="state.assetsOrder == 1"
                      class="w-3 h-3 transform rotate-180"
                      src="@/assets/icons/sort-down.avif"
                      alt=""
                    />
                  </div>
                </td>
                <td>
                  <div
                    class="px-4 cursor-pointer flex items-center"
                    @click="doValuationOrder"
                  >
                    <span class="mr-2"> Valuation </span>

                    <img
                      v-if="state.valuationOrder == -1"
                      class="w-3 h-3"
                      src="@/assets/icons/sort-default.avif"
                      alt=""
                    />
                    <img
                      v-if="state.valuationOrder == 0"
                      class="w-3 h-3"
                      src="@/assets/icons/sort-down.avif"
                      alt=""
                    />
                    <img
                      v-if="state.valuationOrder == 1"
                      class="w-3 h-3 transform rotate-180"
                      src="@/assets/icons/sort-down.avif"
                      alt=""
                    />
                  </div>
                </td>
                <td>
                  <!--  background: #2a2e33ff -->
                  <div
                    class="
                      px-4
                      text-right
                      h-8
                      flex
                      items-center
                      justify-end
                      cursor-pointer
                    "
                  >
                    Owner Address
                  </div>
                </td>
                <td>
                  <div class="px-4 text-right">Details</div>
                </td>
              </thead>
            </table>
            <!-- T-body -->
            <table class="w-full font-bold">
              <colgroup>
                <col style="width: 11%" />
                <col style="width: 36%" />
                <col style="width: 11%" />
                <col style="width: 12.7%" />
                <col style="width: 18.3%" />
                <col style="width: 11%" />
              </colgroup>
              <tbody class="text-left px-6 h-8">
                <tr
                  class="h-14 mt-2 td-hover text-xs"
                  v-for="(item, i) in results"
                  :key="item.tokenName"
                >
                  <td class="bg-white table-shadow-left">
                    <div class="px-4">{{ i + 1 }}</div>
                  </td>
                  <td>
                    <NameCell :item="item"></NameCell>
                  </td>
                  <td>
                    <div class="px-4">
                      {{
                        item.assets > 1000
                          ? numeral(item.assets).format('0.00a').toUpperCase()
                          : item.assets
                      }}
                    </div>
                  </td>
                  <td>
                    <div class="px-4 whitespace-nowrap">
                      <div
                        v-if="
                          daoPageInfo.isFloor.value && !+item.valueFloorPrice
                        "
                      >
                        N/A
                      </div>
                      <ValueCell v-else :isUsdt="isUsdt">
                        {{
                          localeNumber(
                            isUsdt
                              ? daoPageInfo.isFloor.value
                                ? item.valueUsdFloorPrice
                                : item.valueUsd
                              : daoPageInfo.isFloor.value
                              ? item.valueFloorPrice
                              : item.value,
                            2,
                          )
                        }}
                      </ValueCell>

                      <div
                        v-if="
                          isUsdt
                            ? daoPageInfo.isFloor.value
                              ? item.valueUsdFloorPriceRate
                              : item.valueUsdRate
                            : daoPageInfo.isFloor.value
                            ? item.valueFloorPriceRate
                            : item.valueRate
                        "
                      >
                        <span
                          :style="`color:${
                            +(isUsdt
                              ? daoPageInfo.isFloor.value
                                ? item.valueUsdFloorPriceRate
                                : item.valueUsdRate
                              : daoPageInfo.isFloor.value
                              ? item.valueFloorPriceRate
                              : item.valueRate) < 0
                              ? '#FF2640FF'
                              : '#51D55BFF'
                          }`"
                        >
                          {{
                            suffixNum(
                              localFloatNumber(
                                (isUsdt
                                  ? daoPageInfo.isFloor.value
                                    ? item.valueUsdFloorPriceRate
                                    : item.valueUsdRate
                                  : daoPageInfo.isFloor.value
                                  ? item.valueFloorPriceRate
                                  : item.valueRate) * 100,
                                2,
                              ),
                            )
                          }}%
                        </span>
                        <span style="color: #5e6873"> (24H) </span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div
                      class="px-4 text-right cursor-pointer"
                      @click="clickAddress(i)"
                    >
                      <div class="flex items-center justify-end">
                        <tippy
                          :content="item.trackedAddressList[0].address"
                          :arrow="false"
                        >
                          <span class="text-secondary-7">
                            {{
                              formatAddress(
                                item.trackedAddressList[0].address,
                                6,
                              )
                            }}
                          </span>
                        </tippy>

                        <span
                          v-if="item.trackedAddressList.length > 1"
                          class="px-1 rounded-sm ml-1"
                          style="
                            background: rgba(255, 255, 255, 0.1);
                            font-size: 8px;
                          "
                          >+{{ item.trackedAddressList.length }}</span
                        >
                      </div>
                    </div>
                  </td>
                  <!-- 是去到下一个页面!!! -->
                  <td>
                    <div
                      style="color: #268cffff"
                      class="px-4 text-right cursor-pointer"
                      @click="clickDetails({ isProject: true, value: item })"
                    >
                      Details
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- TODO -->
            <div
              class="flex justify-center items-center text-2xl"
              v-if="loading"
            >
              <Spin></Spin>
            </div>

            <!-- TODO 这里是需要加载完成之后才能根据长度判断是否为空 -->
            <div v-if="isEmpty">No Items Found.</div>
          </div>
        </div>
      </CustomTab>
      <CustomTab title="Activity">
        <ActivityList type="NFT"></ActivityList>
      </CustomTab>
    </CustomTabs>
  </div>

  <div
    class="mt-4"
    style="min-height: calc(100vh - 144px)"
    v-if="!state.isActivity && isDesktop"
  >
    <!-- T-header -->
    <table
      class="sticky w-full rounded overflow-hidden"
      style="top: 144px; z-index: 2"
    >
      <colgroup>
        <col style="width: 11%" />
        <col style="width: 36%" />
        <col style="width: 11%" />
        <col style="width: 12.7%" />
        <col style="width: 18.3%" />
        <col style="width: 11%" />
      </colgroup>
      <thead class="text-left px-6 h-16 text-xs" style="background: #2a2e34">
        <td class="table-shadow-left">
          <div class="px-4">#</div>
        </td>
        <td>
          <!--  background: #2a2e33ff -->
          <div class="px-4 h-8 flex items-center">Project</div>
        </td>
        <td>
          <div
            class="px-4 cursor-pointer flex items-center"
            @click="doAssetsOrder"
          >
            <span class="mr-2"> Assets </span>
            <img
              v-if="state.assetsOrder == -1"
              class="w-3 h-3"
              src="@/assets/icons/sort-default.avif"
              alt=""
            />
            <img
              v-if="state.assetsOrder == 0"
              class="w-3 h-3"
              src="@/assets/icons/sort-down.avif"
              alt=""
            />
            <img
              v-if="state.assetsOrder == 1"
              class="w-3 h-3 transform rotate-180"
              src="@/assets/icons/sort-down.avif"
              alt=""
            />
          </div>
        </td>
        <td>
          <div
            class="px-4 cursor-pointer flex items-center"
            @click="doValuationOrder"
          >
            <span class="mr-2"> Valuation </span>

            <img
              v-if="state.valuationOrder == -1"
              class="w-3 h-3"
              src="@/assets/icons/sort-default.avif"
              alt=""
            />
            <img
              v-if="state.valuationOrder == 0"
              class="w-3 h-3"
              src="@/assets/icons/sort-down.avif"
              alt=""
            />
            <img
              v-if="state.valuationOrder == 1"
              class="w-3 h-3 transform rotate-180"
              src="@/assets/icons/sort-down.avif"
              alt=""
            />
          </div>
        </td>
        <td>
          <!--  background: #2a2e33ff -->
          <div
            class="
              px-4
              text-right
              h-8
              flex
              items-center
              justify-end
              cursor-pointer
            "
          >
            Owner Address
          </div>
        </td>
        <td>
          <div class="px-4 text-right">Details</div>
        </td>
      </thead>
    </table>
    <!-- T-body -->
    <table class="w-full font-bold">
      <colgroup>
        <col style="width: 11%" />
        <col style="width: 36%" />
        <col style="width: 11%" />
        <col style="width: 12.7%" />
        <col style="width: 18.3%" />
        <col style="width: 11%" />
      </colgroup>
      <tbody class="text-left px-6 h-8">
        <tr
          class="h-14 mt-2 td-hover text-xs"
          v-for="(item, i) in results"
          :key="item.tokenName"
        >
          <td class="bg-white table-shadow-left">
            <div class="px-4">{{ i + 1 }}</div>
          </td>
          <td>
            <NameCell :item="item"></NameCell>
          </td>
          <td>
            <div class="px-4">
              {{
                item.assets > 1000
                  ? numeral(item.assets).format('0.00a').toUpperCase()
                  : item.assets
              }}
            </div>
          </td>
          <td>
            <div class="px-4 whitespace-nowrap">
              <div v-if="daoPageInfo.isFloor.value && !+item.valueFloorPrice">
                N/A
              </div>
              <ValueCell v-else :isUsdt="isUsdt">
                {{
                  localeNumber(
                    isUsdt
                      ? daoPageInfo.isFloor.value
                        ? item.valueUsdFloorPrice
                        : item.valueUsd
                      : daoPageInfo.isFloor.value
                      ? item.valueFloorPrice
                      : item.value,
                    2,
                  )
                }}
              </ValueCell>

              <div
                v-if="
                  isUsdt
                    ? daoPageInfo.isFloor.value
                      ? item.valueUsdFloorPriceRate
                      : item.valueUsdRate
                    : daoPageInfo.isFloor.value
                    ? item.valueFloorPriceRate
                    : item.valueRate
                "
              >
                <span
                  :style="`color:${
                    +(isUsdt
                      ? daoPageInfo.isFloor.value
                        ? item.valueUsdFloorPriceRate
                        : item.valueUsdRate
                      : daoPageInfo.isFloor.value
                      ? item.valueFloorPriceRate
                      : item.valueRate) < 0
                      ? '#FF2640FF'
                      : '#51D55BFF'
                  }`"
                >
                  {{
                    suffixNum(
                      localFloatNumber(
                        (isUsdt
                          ? daoPageInfo.isFloor.value
                            ? item.valueUsdFloorPriceRate
                            : item.valueUsdRate
                          : daoPageInfo.isFloor.value
                          ? item.valueFloorPriceRate
                          : item.valueRate) * 100,
                        2,
                      ),
                    )
                  }}%
                </span>
                <span style="color: #5e6873"> (24H) </span>
              </div>
            </div>
          </td>
          <td>
            <div
              class="px-4 text-right cursor-pointer"
              @click="clickAddress(i)"
            >
              <div class="flex items-center justify-end">
                <tippy
                  :content="item.trackedAddressList[0].address"
                  :arrow="false"
                >
                  <span style="color: #268cffff">
                    {{ formatAddress(item.trackedAddressList[0].address, 6) }}
                  </span>
                </tippy>

                <span
                  v-if="item.trackedAddressList.length > 1"
                  class="px-1 rounded-sm ml-1"
                  style="background: rgba(255, 255, 255, 0.1); font-size: 8px"
                  >+{{ item.trackedAddressList.length }}</span
                >
              </div>
            </div>
          </td>
          <!-- 是去到下一个页面!!! -->
          <td>
            <div
              style="color: #268cffff"
              class="px-4 text-right cursor-pointer"
              @click="clickDetails({ isProject: true, value: item })"
            >
              Details
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- TODO -->
    <div class="flex justify-center items-center text-2xl" v-if="loading">
      <Spin></Spin>
    </div>

    <!-- TODO 这里是需要加载完成之后才能根据长度判断是否为空 -->
    <div v-if="isEmpty">No Items Found.</div>
  </div>

  <ActivityList type="NFT" v-if="state.isActivity && isDesktop"></ActivityList>

  <Dialog
    :visible="state.show"
    @close="state.show = false"
    boxStyle="width:588px;"
  >
    <div class="text-base font-bold text-whitebase mt-8 mb-6">
      {{ results[state.activeIndex].tokenName }}
    </div>
    <div
      class="relative p-4"
      style="width: 524px; height: 228px; background: #ffffff0d"
    >
      <UiScrollBars class="w-full h-full">
        <div class="flex justify-between text-whitebase">
          <div>Owner address</div>
          <div>Assets</div>
        </div>
        <div class="py-4 space-y-4 text-xs">
          <div
            class="flex justify-between"
            v-for="(item, i) in results[state.activeIndex].trackedAddressList"
            :key="i"
          >
            <div
              class="flex items-center cursor-pointer"
              style="color: #268cffff"
              @click="
                toExploreAddress(item.address, BackNetworkType[item.network])
              "
            >
              {{ item.address }} ({{ NetworkSymbol[item.network] }})
            </div>

            <div class="text-right text-whitebase">
              {{ localeNumber(item.amount, 0) }}
            </div>
          </div>
        </div>
      </UiScrollBars>
    </div>
  </Dialog>
</template>

<script setup>
import {
  defineProps,
  onMounted,
  reactive,
  defineEmits,
  defineExpose,
  watch,
  inject,
  computed,
} from 'vue';
import {
  getDaoIdByPath,
  queryDashboardNftList,
  searchTrackedAddress,
} from '@/api/dao';
import UiImg from '@/components/UiImg.vue';
import { useDesktop, useReqPages } from '@/hooks';
import {
  localeNumber,
  formatAddress,
  toExploreAddress,
  localFloatNumber,
  suffixNum,
} from '@/utils';
import Dialog from '@/components/Dialog.vue';
import NameCell from '../components/NameCell.vue';
import { NetworkSymbol, BackNetworkType } from '@/constants';
import numeral from 'numeral';
import UiScrollBars from '@/components/UiScrollbars.vue';
import ValueCell from '../components/ValueCell.vue';
import SearchCell from '../components/SearchCell.vue';
import Spin from '@/components/Spin.vue';
import ContractSearch from '../components/ContractSearch.vue';
import { useRoute, useRouter } from 'vue-router';
import { useInfiniteScroll } from '@vueuse/core';
import { withThrottling } from '@/utils/with';
import ActivityList from '../components/ActivityList';
import CustomTabs from '@/components/CustomTabs.vue';
import CustomTab from '@/components/CustomTab.vue';
const isDesktop = useDesktop('lg');
const daoPageInfo = inject('daoPageInfo');
const $emits = defineEmits(['details']);
const $route = useRoute();
const $router = useRouter();

const state = reactive({
  // address
  show: false,
  activeIndex: 0,
  searchAddress: null,
  searchProject: '',
  assetsOrder: -1,
  valuationOrder: 0,

  isActivity: $route.params?.state?.toLowerCase() === 'activity' ? true : false,
});

const props = defineProps({
  includeOwnAssets: Boolean,
});

const isUsdt = computed(() => daoPageInfo.vueState.byUnit.value == 'USDT');

const { loadNext, loadRest, loading, results, isEmpty } = useReqPages(
  async (page, cancel) => {
    const orderItem =
      state.assetsOrder != -1
        ? 'assets'
        : state.valuationOrder != -1
        ? 'valueUsd'
        : '';

    const orderType =
      state.valuationOrder == 0 || state.assetsOrder == 0 ? 'desc' : 'asc';

    const res = await queryDashboardNftList(
      await getDaoIdByPath($route.params.name),
      page,
      {
        ...(state.searchAddress
          ? {
              ownerAddress: state.searchAddress.trackedAddress,
              chain: state.searchAddress.network,
            }
          : {
              orderItem,
              orderType,
            }),
        projectName: state.searchProject,
        includeOwnAssets: daoPageInfo.vueState.includeOwnAssets,
      },
      cancel,
    );

    const result = {
      lists: res.records,
      rows: res.size,
      total: res.total,
      pages: res.pages,
    };
    return result;
  },
);

const clickAddress = (i) => {
  state.activeIndex = i;
  state.show = true;
};

const clickDetails = (info) => {
  console.log(info);
  if (info) {
    localStorage.setItem('TEMP_NFT_DATA', JSON.stringify(info));

    $router.push(
      `/dao/${$route.params.name}/treasury/nft/detail/${
        info.value.tokenName ? info.value.tokenName : info.value.name
      }`,
    );
  }
};

const jump = (name) => {
  if (name) {
    window.open(
      `${process.env.VUE_APP_VAULT_PATH}#/Collectables/${name}`,
      '_blank',
    );
  }
};

const onAddressSearch = async (word) =>
  searchTrackedAddress(await getDaoIdByPath($route.params.name), false, word);

const doAddressSearch = (item) => {
  if (state.searchAddress != item) {
    state.searchAddress = item;
    loadRest();
  }
};

const doAssetsOrder = () => {
  state.valuationOrder = -1;
  state.assetsOrder = +!state.assetsOrder;
};

const doValuationOrder = () => {
  state.assetsOrder = -1;
  state.valuationOrder = +!state.valuationOrder;
};

watch(
  () =>
    JSON.stringify([
      state.searchProject,
      state.assetsOrder,
      state.valuationOrder,
      daoPageInfo.vueState.includeOwnAssets,
    ]),
  () => {
    loadRest(true);
  },
);

useInfiniteScroll(window, withThrottling(loadNext), {
  distance: 44,
});

watch(
  () => $route.params.state,
  () => {
    console.log('$route.params', $route.params.state);
    if ($route.params.state === 'activity') {
      state.isActivity = true;
    } else {
      state.isActivity = false;
    }
  },
);

watch(
  () => state.isActivity,
  () => {
    console.log('state', state.isActivity);
    const newParams = {
      ...$route.params,
      state: state.isActivity ? 'activity' : 'asset',
    };
    $router.replace({ params: newParams });
  },
);

onMounted(() => {
  if ($route.params.state === 'activity') {
    state.isActivity = true;
  } else {
    state.isActivity = false;
  }

  loadRest();
});

defineExpose({
  loadNext,
});
</script>

<style scoped>
.td-hover:hover {
  background: #1e2022;
}
.td-hover:hover .table-shadow-left {
  background: #1e2022;
}
.topa-btn {
  height: 40px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
}
.topa-btn__active {
  background: #ff5585ff;
  border: 1px solid #ff5585ff;
}
</style>
